import {getRouterConfig} from './config'
import {Location as LocationType} from 'history'
import {appsList, setCurrentBaseAppPath} from './apps'
import {trim} from 'core/utility/string'
import {Certificate} from 'crypto'
import {currentRoute} from './navigator'

/**
 * build path with the given paths to th single path
 *
 * @param {string[]} segments
 * @returns {string}
 */
export function concatPath(...segments: string[]) {
  let path: string = segments
    .filter((segment) => segment && String(segment).length > 0)
    .map(function (segment) {
      return '/' + trim(segment, '/')
    })
    .join('')

  return '/' + trim(path.replace(/(\/)+/g, '/'), '/')
}

/**
 * get application local codes
 *
 * @returns {string[]}
 */
export function getLocaleCodes(): string[] {
  return getRouterConfig('localeCodes', [])
}

/**
 * get the first segment of the given location
 *
 * @param {Location} location
 * @return {string}
 */
export function firstSegment(location: Location | LocationType) {
  let [firstSegment, secondSegment, thirdSegment] = location.pathname.replace(/^\//, '').split('/')

  let segment = firstSegment

  // Check if the first segment is local code
  const localCodes = getLocaleCodes()

  if (localCodes.includes(segment)) {
    // Check if the second segment is app name
    if (appsList.includes('/' + secondSegment)) {
      setCurrentBaseAppPath(secondSegment)
      segment = thirdSegment || ''
    } else {
      segment = secondSegment || ''
    }
  } else if (appsList.includes('/' + segment)) {
    setCurrentBaseAppPath(firstSegment)

    segment = secondSegment || ''
  }

  return segment ? concatPath(segment) : '/'
}

/**
 * Get the base path of application
 *
 * @returns {string}
 */
export function basePath(): string {
  return getRouterConfig('basePath', '/')
}

/**
 * Check if the given route is the current route
 *
 * @param {string} route
 * @return {boolean}
 */
export function checkActiveRoute(route: string) {
  const current = currentRoute()

  

  return current === route
}

/**
 * current direction
 *
 * @returns {string}
 */
export function currentDirection(): string {
  return document.documentElement.dir || 'ltr'
}

/**
 * Check if direction
 *
 * @param   {string} direction
 * @returns {boolean}
 */
export function isDirection(direction: 'ltr' | 'rtl'): boolean {
  return currentDirection() === direction
}
